import { PopperProps } from '@mui/material/Popper'
import {
  base_colorRaisedSurface,
  cta_buttonPrimaryText,
  text_colorTextSecondary,
  tooltip_colorBorder,
  tooltip_colorDefaultSurface,
  tooltip_colorSpotlightSurface,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { font_family_weight_medium, font_sm } from 'ext-ui/style/typography'
import styled, { css } from 'styled-components'

export const styles = css``
/** makes use of the internal Popper component from MUI
 *  https://popper.js.org/docs/v2/modifiers/offset/
 * to account for our own design system's spacing
 */
export const tooltipOffset = (placement: PopperProps['placement']) => {
  switch (placement) {
    case 'top':
      return [0, 8]
    case 'top-start':
      return [-8, 8]
    case 'top-end':
      return [8, 8]
    case 'bottom-start':
    case 'left-start':
    case 'right-start':
      return [-8, 8]
    case 'bottom-end':
    case 'left-end':
    case 'right-end':
      return [8, 8]
    case 'bottom':
    case 'left':
    case 'right':
    default:
      return [0, 8]
  }
}

export const TooltipContainer = styled.div`
  display: flex;
  max-width: 200px;
  gap: ${spacing(1)};
  border-radius: ${spacing(2)};
  padding: ${spacing(3)};
  font-family: ${font_family_weight_medium};
  ${font_sm}

  &.arrow:before {
    content: '';
    position: absolute;
    border-width: ${spacing(2)};
    border-style: solid;
  }

  // variant
  &.default {
    background-color: ${tooltip_colorDefaultSurface};
    color: ${cta_buttonPrimaryText};
    &:before {
      border-color: ${tooltip_colorDefaultSurface};
    }
  }

  &.spotlight {
    background-color: ${tooltip_colorSpotlightSurface};
    color: ${cta_buttonPrimaryText};
    &:before {
      border-color: ${tooltip_colorSpotlightSurface};
    }
  }

  &.light {
    background-color: ${base_colorRaisedSurface};
    color: ${text_colorTextSecondary};
    border: 1px solid ${tooltip_colorBorder};
    box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
    &:before {
      border-color: ${base_colorRaisedSurface};
    }
  }

  // placement

  &.top,
  &.top-start,
  &.top-end {
    &:before {
      border-bottom-color: transparent;
      border-left-color: transparent;
      border-right-color: transparent;
    }
  }

  &.top:before {
    top: 100%;
    left: 50%;
    margin-left: -${spacing(2)};
  }

  &.top-start:before {
    top: 100%;
    left: ${spacing(3)};
  }

  &.top-end:before {
    top: 100%;
    right: ${spacing(3)};
  }

  &.bottom,
  &.bottom-start,
  &.bottom-end {
    &:before {
      border-top-color: transparent;
      border-left-color: transparent;
      border-right-color: transparent;
    }
  }

  &.bottom:before {
    bottom: 100%;
    left: 50%;
    margin-left: -${spacing(2)};
  }

  &.bottom-start:before {
    bottom: 100%;
    left: ${spacing(3)};
  }

  &.bottom-end:before {
    bottom: 100%;
    right: ${spacing(3)};
  }

  &.left,
  &.left-start,
  &.left-end {
    &:before {
      border-top-color: transparent;
      border-bottom-color: transparent;
      border-right-color: transparent;
    }
  }

  &.left:before {
    left: 100%;
    top: 50%;
    margin-top: -${spacing(2)};
  }

  &.left-start:before {
    left: 100%;
    top: ${spacing(3)};
  }

  &.left-end:before {
    left: 100%;
    bottom: ${spacing(3)};
  }

  &.right,
  &.right-start,
  &.right-end {
    &:before {
      border-top-color: transparent;
      border-bottom-color: transparent;
      border-left-color: transparent;
    }
  }

  &.right:before {
    right: 100%;
    top: 50%;
    margin-top: -${spacing(2)};
  }

  &.right-start:before {
    right: 100%;
    top: ${spacing(3)};
  }

  &.right-end:before {
    right: 100%;
    bottom: ${spacing(3)};
  }
`
